import { ButtonClassType } from '../../../../enums/buttons';
import Color from '../../../../enums/color';
import { getSimplifiedColorCode } from '../../../../helpers/color';
const flatButtonStyle = `
  &.kpmg-button-${ButtonClassType.Flat} {
    background: transparent;
    
    &.disabled {
      color: ${Color.Grey187};
      cursor: default;
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.Black)} {
      color: ${Color.Black};
    
      &:hover {
        background: ${Color.Grey223};
      }
      
      &:active {
        background: ${Color.Grey187};
      }
    }
    
    &.colorTheme-${getSimplifiedColorCode(Color.MicrosoftBlue)} {
      color: ${Color.MicrosoftBlue};
      
      &:hover {
        background: ${Color.HawkesBlue};
      }
      
      &:active {
        color: ${Color.White};
        background: ${Color.MicrosoftBlue};
      }
    }
  }
`;
export default flatButtonStyle;
